import { render, staticRenderFns } from "./CodeEdit.vue?vue&type=template&id=33c64ab8&scoped=true"
import script from "./CodeEdit.vue?vue&type=script&lang=js"
export * from "./CodeEdit.vue?vue&type=script&lang=js"
import style0 from "./CodeEdit.vue?vue&type=style&index=0&id=33c64ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c64ab8",
  null
  
)

export default component.exports